module.exports = __webpack_public_path__ + "static/media/fingerprint.b1f016a8.svg";